import { Link, useNavigate } from "react-router-dom";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";
import { useGetOrganizationsQuery } from "../generated/graphql";
import { useEffect, useState } from "react";
import { useAuth } from "../AuthProvider";
import { Badge, ChevronsUpDown } from "lucide-react";
import { Button } from "./ui/button";
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from "./ui/command";

export function Navbar() {
  const navigate = useNavigate();
  const { organizationId, setOrganizationId } = useAuth();
  const [open, setOpen] = useState(false);

  const [{ data: OrgData }, getOrganizations] = useGetOrganizationsQuery();
  const organizations = OrgData?.getOrganizations;
  const userHasPendingSwaps = organizations?.some((org) => org.hasPendingSwaps);

  // Poll getOrganiztiaon every 30S
  useEffect(() => {
    const interval = setInterval(() => {
      getOrganizations({
        requestPolicy: "network-only",
      });
    }, 30000);
    return () => clearInterval(interval);
  }, [getOrganizations]);

  useEffect(() => {
    if (
      !organizationId &&
      organizations &&
      organizations.length > 0 &&
      setOrganizationId
    ) {
      setOrganizationId(organizations[0].id);
    }
  }, [organizations, setOrganizationId, organizationId]);

  const selectedOrg = organizations?.find((org) => org.id === organizationId);

  organizations?.sort((a, b) => {
    // Convert names to lowercase for case-insensitive sorting
    const nameA = a.name.toLowerCase();
    const nameB = b.name.toLowerCase();

    if (nameA < nameB) return -1;
    if (nameA > nameB) return 1;
    return 0;
  });

  return (
    <header
      className="sticky top-0 flex h-16 items-center gap-4 border-b bg-background px-4 md:px-6"
      style={{
        minHeight: "64px",
        zIndex: 50,
      }}
    >
      <nav className=" gap-6 text-lg font-medium flex flex-row items-center md:gap-5 md:text-sm lg:gap-6">
        <Link
          to="/"
          className="flex items-center gap-2 text-lg font-semibold md:text-base"
        >
          <img
            src={require("../logo.png")}
            alt="Block Kingz"
            className="h-8 w-12"
          />
        </Link>

        {organizations && organizations.length > 0 && (
          <div style={{ position: "relative" }}>
            <Popover open={open} onOpenChange={setOpen}>
              <PopoverTrigger asChild>
                <Button
                  variant="outline"
                  role="combobox"
                  aria-expanded={open}
                  className="w-[250px] justify-between"
                >
                  <div style={{ display: "flex", alignItems: "center" }}>
                    {selectedOrg?.name
                      ? selectedOrg.name
                      : "Select Organization..."}
                  </div>
                  <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
                </Button>
              </PopoverTrigger>
              <PopoverContent className="w-[250px] p-0">
                <Command style={{ pointerEvents: "auto" }}>
                  <div style={{ pointerEvents: "auto" }}>
                    <CommandInput placeholder="Search organizations..." />
                    <CommandList>
                      <CommandEmpty>No organizations found</CommandEmpty>
                      <CommandGroup>
                        {organizations.map((org) => (
                          <CommandItem
                            key={org.id}
                            value={org.name}
                            onSelect={(currentValue) => {
                              setOrganizationId(org.id);
                              setOpen(false);
                              navigate("/");
                            }}
                          >
                            {org.name}
                            {org.hasPendingSwaps && (
                              <Badge
                                style={{
                                  position: "absolute",
                                  top: "50%",
                                  right: "5px",
                                  transform: "translateY(-50%)",
                                  color: "red",
                                  height: "15px",
                                }}
                              >
                                Pending
                              </Badge>
                            )}
                          </CommandItem>
                        ))}
                      </CommandGroup>
                    </CommandList>
                  </div>
                </Command>
              </PopoverContent>
            </Popover>
            {userHasPendingSwaps && (
              <Badge
                style={{
                  position: "absolute",
                  top: "0px",
                  right: "-10px",
                  transform: "translateY(-50%)",
                  color: "red",
                  height: "15px",
                }}
              >
                Pending
              </Badge>
            )}
          </div>
        )}
      </nav>
    </header>
  );
}
